/**
 * Fallback Routing
 * 
 * Route around when target is above or at same level as source
 */

import { NODE_WIDTH, CORNER_RADIUS, MIN_PERPENDICULAR_DISTANCE, ROUTING_OBSTACLE_INFLATION } from '../constants';
import { buildPathWithCorners } from '../pathBuilders';
import { filterRedundantPoints } from './repairPath';

const EXIT_CLEARANCE = MIN_PERPENDICULAR_DISTANCE + CORNER_RADIUS;

/**
 * Route around when target is above or at same level as source
 */
export function routeAround(startX, startY, endX, endY, fromPos, toPos, fromDims, toDims, obstacles) {
  const fromWidth = fromDims?.width || NODE_WIDTH;
  const toWidth = toDims?.width || NODE_WIDTH;
  
  const goRight = endX >= startX;
  
  let outerX;
  if (goRight) {
    const rightEdge = Math.max(fromPos.x + fromWidth, toPos.x + toWidth);
    outerX = rightEdge + ROUTING_OBSTACLE_INFLATION * 2;
  } else {
    const leftEdge = Math.min(fromPos.x, toPos.x);
    outerX = leftEdge - ROUTING_OBSTACLE_INFLATION * 2;
  }
  
  for (const node of obstacles) {
    if (!node.pos || !node.dims) continue;
    const nodeLeft = node.pos.x - ROUTING_OBSTACLE_INFLATION;
    const nodeRight = node.pos.x + (node.dims.width || NODE_WIDTH) + ROUTING_OBSTACLE_INFLATION;
    
    if (goRight && outerX < nodeRight && outerX > nodeLeft) {
      outerX = nodeRight + ROUTING_OBSTACLE_INFLATION;
    } else if (!goRight && outerX > nodeLeft && outerX < nodeRight) {
      outerX = nodeLeft - ROUTING_OBSTACLE_INFLATION;
    }
  }
  
  const exitY = startY + EXIT_CLEARANCE;
  const entryY = endY - EXIT_CLEARANCE;
  
  const points = [
    { x: startX, y: startY },
    { x: startX, y: exitY },
    { x: outerX, y: exitY },
    { x: outerX, y: entryY },
    { x: endX, y: entryY },
    { x: endX, y: endY },
  ];
  
  return buildPathWithCorners(filterRedundantPoints(points), CORNER_RADIUS);
}
